import React from 'react';
import {injectIntl} from 'react-intl';
import {action} from 'mobx'
import {observer} from 'mobx-react'
import {Button} from 'react-bootstrap'
import BmcCard from "./stores/BmcCard";

@observer
class SuggestCard extends React.Component {
    constructor(props) {
        super(props);


        this.state = {};
        this.name = props.card.name ? props.intl.formatMessage({id: props.card.name}) : "";
        this.description = props.card.description ? props.intl.formatMessage({id: props.card.description}) : "";
        this.crPurpose = props.card.crPurpose ? props.intl.formatMessage({id: props.card.crPurpose}) : "";
        this.utility = props.card.utility ? props.intl.formatMessage({id: props.card.utility}) : "";

        this.addSuggest = this.addSuggest.bind(this);
    }

    render() {
        const {blockStore, card, intl} = this.props;
        // don't render if its empty or already added as a card in the block
        if ((this.name === "" && this.description === "") || blockStore.cards.find(c => c.name === this.name)) {
            return null;
        }


        return (
            <li className="card suggest-card" style={{position: "relative"}}>
                <span className="badge">{this.name}</span>
                <br/>
                <div className="suggest-card-description-container">
                    {this.description}
                </div>
                &nbsp;
                <Button bsStyle="default" bsSize="small" className="negative-top-right"
                        onClick={this.addSuggest}
                >
                    {/*intl.formatMessage({id: "add"})*/}
                    <i className="fa fa-plus" aria-hidden="true"/>
                </Button>
            </li>
        );
    }

    @action
    addSuggest() {
        const {blockStore, card, intl} = this.props;

        // const _card = Object.assign({}, card);
        const _card = new BmcCard(blockStore, {}, false);


        // updated card's localized attributes
        _card.name = this.name !== '-' ? this.name : "";
        _card.description = this.description !== '-' ? this.description : "";
        _card.crPurpose = this.crPurpose !== '-' ? this.crPurpose : "";
        _card.utility = this.utility !== '-' ? this.utility : "";

        blockStore.addCard(_card)
    }

}

export default injectIntl(SuggestCard);